<template>
    <div class="modalx"
        v-bind:style="{ 'background-image': 'url(https://admin.itsyourdayofficial.com/foto_cover/'+client.foto_cover+')'}"
        loading="lazy">
        <div class="overlayy"></div>
        <div class="content-modalx">
            <div class="info_modalx">
                <div class="elementor-image img">
                    <img decoding="async" src="assets/wp-content/uploads/2023/02/blank.png" title="QW-009" alt="QW-009" />
                </div>
                <div class="lws-mempelai" v-if="client.hajat == 'pria'" style="color: #f1bcb3;">
                    {{ client.nama_pria }} &amp; {{ client.nama_wanita }}
                </div>
                <div class="lws-mempelai" v-if="client.hajat == 'wanita'" style="color: #f1bcb3;">
                    {{ client.nama_wanita }} &amp; {{ client.nama_pria }}
                </div>
                <div class="lws-dear" style="font-family: 'Dancing Script', cursive; font-size: 18px; color: #f1bcb3;">
                    Kepada Bapak/Ibu/Saudara/i
                </div>
                <div class="lws-name" style="font-size: 30px; color: #fbd8c2;" >
                    {{guest.nama}}
                </div>
                <div v-if="showName" class="lws-name" style="font-size: 30px; color:#fbd8c2;">
                    {{name}}
                </div>
                
                <div class="lws-button-wrapper">
                    <button class="elementor-button" @click="close" style="color: #f1bcb3; border-color:#f1bcb3;">
                      {{ config.language === 1 ? "Open Invitation" : 'Buka Undangan' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Modal',
  props: ['client', 'guest', 'config'],
  methods: {
    close() {
      this.$emit('close');
    },
    getOriginalQueryParam(paramName) {
      if (typeof window === 'undefined') return null;
      const queryString = window.location.search;
      const regex = new RegExp(`[?&]${paramName}=([^&]+)`);
      const matches = regex.exec(queryString);
      return matches && matches.length > 1 ? matches[1] : null;
    }
  },
  computed: {
    // Tampilan fallback nama, yaitu hasil decode dari query parameter `to`
    name() {
      const toParam = this.getOriginalQueryParam('to');
      return toParam ? decodeURIComponent(toParam) : '';
    },
    // Hanya tampilkan computed name jika guest.nama tidak tersedia.
    showName() {
      // Jika guest.nama ada ataupun tidak hanya spasi, tidak perlu tampilan tambahan.
      return (!this.guest || !this.guest.nama) && !!this.getOriginalQueryParam('to');
    }
  },
};
</script>